import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const PAYMENT_API_URL = process.env.REACT_APP_PAYMENT_API_URL;
const HANDSFREE_URL = 'https://stage.handsfreeapi.com/';

export default {
  async GetStats(data) {
    try {
      const tokenResponse = await this.GetToken();
      const token = localStorage.getItem('tokenForService');
      return axios({
        method: 'post',
        url: `${API_URL}flow/analytics-get-general`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        data: data,
      });
    } catch (error) {
      console.error('Error in GetStats:', error);
      throw error;
    }
  },
  async CreateOrder(array) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}mall-logistics/create`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: array,
    });
  },

  Login(username, password) {
    return axios({
      method: 'post',
      url: `${API_URL}login`,
      data: {
        username: username,
        password: password,
      },
    });
  },

  ForgotPassword(token, username) {
    return axios({
      method: 'post',
      url: `${API_URL}users/forgot-password`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        username: username,
      },
    });
  },

  GetLocation(token, branchID) {
    return axios({
      method: 'post',
      url: `${API_URL}locations/get-locations`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        branchID: branchID,
      },
    });
  },

  GetPosts(token, status) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/get`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: status,
        withPosts: true,
        limit: 10000,
      },
    });
  },

  GetPostByOnlyBarcode(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/post-search-barcode`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: [barcode],
        withLogs: true,
      },
    });
  },

  GetArasKargoEcommerceCompanyList(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-aras-kargo-db-ecommerce-company-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  SetInBranch(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/set-in-branch`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: [postID],
      },
    });
  },

  PostComplete(token, barcode, otpType, otp) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/complete`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
        otpType: otpType,
        otp: otp,
      },
    });
  },

  PostCompleteForDHL(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/complete`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID,
      },
    });
  },

  PostCompleteByID(token, postID, otpType, otp) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/complete`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        otpType: otpType,
        otp: otp,
      },
    });
  },

  PostReturn(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/post-return-complete`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },

  GetUsers(token, status) {
    return axios({
      method: 'post',
      url: `${API_URL}users/get-users`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: status,
        withAuthOffices: true,
      },
    });
  },

  GetUser(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}users/get-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
        withAuthOffices: true,
      },
    });
  },

  CreateTicket(token, title, description, type, files, username) {
    //console.log(token, title, description, type, files, username, '--------');
    return axios({
      method: 'post',
      url: `${API_URL}support/create-ticket`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        description: description,
        files: files,
        type: type,
        username: username,
      },
    });
  },

  GetUserByID(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}users/get-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  GetUserForTickets(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}users/get-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  GetTickets(token, status) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-tickets`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: status,
      },
    });
  },

  GetTicketsUser(token, createdBy) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-tickets`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        createdBy: createdBy,
      },
    });
  },

  GetTicketsStaff(token, responsibleBy) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-tickets`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        responsibleBy: responsibleBy,
        status: 3,
        operator: 'or',
      },
    });
  },

  GetTicketsManager(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-tickets`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: [1, 3, 4],
      },
    });
  },

  GetTicket(token, id) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-ticket`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id: id,
      },
    });
  },

  GetTicketsByUser(token, createdBy) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-tickets`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        createdBy: createdBy,
      },
    });
  },

  CreateTicketForPostDetail(token, title, description) {
    return axios({
      method: 'post',
      url: `${API_URL}support/create-ticket`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        description: description,
        files: [],
        type: 'EasyNet',
      },
    });
  },

  ResendCode(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/post-recreate-deliver-password`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
      },
    });
  },

  GetUserTypes(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/users-get-types`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetPoints(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-points`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  CreateEmployee(token, user) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/users-create-employee`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: user,
    });
  },

  UpdateProfile(token, user) {
    return axios({
      method: 'post',
      url: `${API_URL}users/update-profile`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: user,
    });
  },

  GetToken() {
    return axios({
      method: 'post',
      url: `${API_URL}get-token`,
      data: {
        key: 'wHjOKqH25WwOEeHphyGR',
        secret: '37m2LWciLhboNNFA6UkQ',
      },
    });
  },

  GetSurvey(token, surveyID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-surveys`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        surveyID,
      },
    });
  },

  GetAgreement(token, handle) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/agreements-get-static`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        handle: handle,
      },
    });
  },

  PostCancel(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/cancel`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
      },
    });
  },

  GetCheckRooms(token, status, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/checkroom-get`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: status,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  async GetPaymentTypes() {
    const tokenResponse = await axios({
      method: 'post',
      url: `${API_URL}get-token`,
      data: {
        key: 'wHjOKqH25WwOEeHphyGR',
        secret: '37m2LWciLhboNNFA6UkQ',
      },
    });

    const token = tokenResponse.data.result.token;

    return axios({
      method: 'post',
      url: `${API_URL}flow/get-payments-types`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  SetPaymentStatus(token, postID, paymentType, invoiceID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/post-set-paid`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        paymentType: paymentType,
        invoiceID: invoiceID,
      },
    });
  },

  SendPanic(token, message) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/i-panic`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        message: message,
      },
    });
  },

  GetReport(token, queryType, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-report`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'auto',
        queryType: queryType,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  UserSetActive(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/user-set-active`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  UserSetPassive(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/user-set-passive`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  GetStatistics(token, data) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-statistics`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  GetBolParaCompanies(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-bol-para-companies`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  BolParaAboutToken(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/about-token`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetBolParaCompanyCampaigns(token, companyID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-bolpara-campaigns`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID: companyID,
      },
    });
  },

  GetBolParaCampaign(token, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-bolpara-campaign`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
      },
    });
  },

  CreateBolParaCompany(token, title, logo) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/create-bol-para-company`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        logo: logo,
      },
    });
  },

  UpdateBolParaCompany(token, companyID, title, logo, status) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/update-bol-para-company`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID: companyID,
        title: title,
        logo: logo,
        status: status,
      },
    });
  },

  UpdateBolParaCompanyBasedGetCouponButtonVisibleStatus(token, companyID, brandBasedGetCouponButtonVisibleStatus, title, status) {
    console.log("Button Gösterme:", brandBasedGetCouponButtonVisibleStatus)
    return axios({
      method: 'post',
      url: `${API_URL}flow/update-bol-para-company`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        status: status,
        companyID,
        brandBasedGetCouponButtonVisibleStatus
      },
    });
  },

  BolParaMassUpdateStatus(token, list) {
    console.log(list);
    return axios({
      method: 'post',
      url: `${API_URL}flow/bol-para-mass-update-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        list: list,
      },
    });
  },

  CreateBolParaCampaign(
    token,
    title,
    prefix,
    companyID,
    description,
    images,
    start,
    end,
    type,
    allowedPoints,
    hasForm
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/create-bol-para-campaign`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        prefix: prefix,
        companyID: companyID,
        description: description,
        images: images,
        start: start,
        end: end,
        type: type,
        allowedPoints: allowedPoints,
        hasForm
      },
    });
  },

  AddBolParaAgreement(token, campaignID, title, content) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/add-bol-para-agreement`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
        title: title,
        content: content,
      },
    });
  },

  GetBolParaAgreement(token, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-bol-para-agreements`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
      },
    });
  },

  UpdateBolParaAgreement(token, agreementID, title, content) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/update-bol-para-agreement`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        agreementID: agreementID,
        title: title,
        content: content,
      },
    });
  },

  DeleteBolParaAgreement(token, agreementID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/remove-bol-para-agreement`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        agreementID: agreementID,
      },
    });
  },

  UpdateBolParaCampaign(
    token,
    campaignID,
    title,
    prefix,
    companyID,
    description,
    images,
    start,
    end,
    type,
    allowedPoints,
    hasForm
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/update-bol-para-campaign`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
        title: title,
        prefix: prefix,
        companyID: companyID,
        description: description,
        images: images,
        start: start,
        end: end,
        type: type,
        allowedPoints: allowedPoints,
        hasForm
      },
    });
  },

  RemoveBolParaCampaign(token, campaignID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/update-bol-para-campaign`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
        status: false,
      },
    });
  },

  GetBolParaResponses(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-bol-para-responses`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetBolParaResponsesWithPoi(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-bol-para-responses`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        poiID: poiID,
      },
    });
  },

  UpdateBolParaResponse(token, responseID, status) {
    console.log(token);
    return axios({
      method: 'post',
      url: `${API_URL}flow/update-bol-para-response-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        responseID: responseID,
        status: status,
      },
    });
  },

  GetCampaigns(token) {
    return axios({
      method: 'post',
      url: `${API_URL}campaigns/get-campaigns`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        audiences: ['esnaf', 'easypoint', 'personal-customers'],
        allCampaigns: true,
      },
    });
  },

  CreateCampaign(
    token,
    title,
    description,
    start,
    end,
    images,
    link,
    targetAudience,
    hasForm,
    selectedFormID
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}campaigns/create`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        description: description,
        targetAudience: targetAudience,
        start: start,
        end: end,
        link: link,
        images: images,
        hasForm,
        selectedFormID
      },
    });
  },
  UpdateCampaign(
    token,
    campaignID,
    title,
    description,
    start,
    end,
    images,
    link,
    targetAudience,
    status,
    hasForm,
    selectedFormID
  ) {

    console.log("service form id:", hasForm, selectedFormID)
    return axios({
      method: 'post',
      url: `${API_URL}campaigns/update`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
        title: title,
        description: description,
        targetAudience: targetAudience,
        start: start,
        end: end,
        link: link,
        images: images,
        status: status,
        hasForm,
        selectedFormID
      },
    });
  },
  GetArasKargoEcommerceCompanyList(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/aras-kargo-get-ecommerce-company-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  AcceptArasKargoEcommerceReturn(token, accountID, orderCode, prePrintBarcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/aras-kargo-ecommerce-return-accept`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        accountID: accountID,
        orderCode: orderCode,
        prePrintBarcode: prePrintBarcode,
      },
    });
  },
  ArasKargoDropOffQrCheck(token, deliveryCode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/aras-kargo-drop-off-qr-check`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        deliveryCode: deliveryCode,
      },
    });
  },
  ArasKargoDropOffAccept(token, deliveryCode, prePrintBarcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/aras-kargo-drop-off-accept`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        deliveryCode: deliveryCode,
        prePrintBarcode: prePrintBarcode,
      },
    });
  },
  GetArasKargoPosts(token) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/get`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: [9],
        withPosts: false,
      },
    });
  },
  ReturnArasKargoPost(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: [
        {
          postID: postID,
          status: 40,
        },
      ],
    });
  },
  ReturnShopifyPost(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: [
        {
          postID: postID,
          status: 45,
        },
      ],
    });
  },

  ChangeShopifyPostStatusToWillReturn(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: [
        {
          postID: postID,
          status: 9,
        },
      ],
    });
  },
  ResendArasKargoOTP(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/aras-kargo-send-otp`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },
  ArasKargoPostComplete(token, barcode, customerNameLastname, otp) {
    return axios({
      method: 'post',
      url: `${API_URL}posts/complete`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
        customerNameLastname: customerNameLastname,
        otpType: 'ArasKargoOTP',
        otp: otp,
      },
    });
  },
  GetDropboxListByLocations(token, locationCode, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/drop-box-list-by-location-code`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  DeliverPostWithTC(token, postID, tckn) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/deliver-post-with-tckn`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        tckn: tckn,
      },
    });
  },

  DeliverPostWithTC(token, postID, tckn) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/deliver-post-with-tckn`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        tckn: tckn,
      },
    });
  },
  DeliverManually(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/deliver-post-manually`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
      },
    });
  },
  GetStatusList(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-post-statuses`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  SetInBranchFromOnPorter(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/set-in-branch-from-on-porter`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },
  GetCities(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-cities`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  GetTowns(token, cityCode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-towns`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        cityCode: cityCode,
      },
    });
  },
  GetRegions(token, townCode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-districts`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        townCode: townCode,
      },
    });
  },
  GetLockerLocations() {
    return axios({
      method: 'get',
      url: `https://api.easypoint.com.tr/LockerTrack/locations`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  GetLockers(locationCode) {
    return axios({
      method: 'get',
      url: `https://api.easypoint.com.tr/LockerTrack/location/${locationCode}/lockers`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  LockerLoad(qrCode) {
    return axios({
      method: 'post',
      url: `https://api.easypoint.com.tr/LockerTrack/loadLocker`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        qrCode,
      },
    });
  },
  FinishBox(qrCode) {
    return axios({
      method: 'post',
      url: `https://api.easypoint.com.tr/LockerTrack/finishBox`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        qrCode,
      },
    });
  },

  GetPostLogsSearch(token, barcode, type, createdBy, startDate, endDate, log) {
    const data = {};
    if (barcode) data.barcode = barcode;
    if (type) data.type = type;
    if (createdBy) data.createdBy = createdBy;
    if (startDate) data.startDate = startDate;
    if (endDate) data.endDate = endDate;
    if (log) data.log = log;

    return axios({
      method: 'post',
      url: `${API_URL}flow/get-easypoint-post-logs`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  GetPostLogsTypes(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-easypoint-post-log-types`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  CheckEasypointCenterDuplicate(token, field, value) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/check-easypoint-center-duplicate`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        field,
        value,
      },
    });
  },

  CreateOperationReport(token, data, operationType) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/create-operation-report`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        operationType: operationType,
        data: data,
      },
    });
  },

  GetOperationReport(token, operationType) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-operation-report`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        operationType: operationType,
      },
    });
  },

  UpdateOperationReport(token, data, operationType) {
    console.log({ operationType, data });
    return axios({
      method: 'post',
      url: `${API_URL}flow/update-operation-report`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        operationType: operationType,
        data: data,
      },
    });
  },

  TakeEcommerce(token, easypointID, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/aras-kargo-manager-package-approve`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
        easypointID: easypointID,
      },
    });
  },

  DHLPackageApprove(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-package-approve`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },

  DHLDropOffAccept(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-drop-off-accept`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode: barcode,
      },
    });
  },

  GetVideos(token, type) {
    console.log('type video: ', type);
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-training-videos`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  GetDocuments(token, type) {
    console.log('type doc: ', type);
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-training-documents`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  GetFaq(token, type) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-faq`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  CreateFaq(token, faq) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/create-faq`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: faq.title,
        description: faq.description,
        type: faq.type,
      },
    });
  },

  UpdateFaq(token, id, title, description, type) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/update-faq`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id,
        title,
        description,
        type,
      },
    });
  },

  RemoveFaq(token, id) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/remove-faq`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id,
      },
    });
  },

  GetKidCarOrders(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/easydesk-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'kid-car',
        poiID: poiID,
      },
    });
  },

  GetPetCarOrders(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/easydesk-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'pet-car',
        poiID: poiID,
      },
    });
  },
  GetGiftOrders(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/easydesk-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'gift',
        poiID: poiID,
      },
    });
  },
  GetVehicleInventory(token, mallID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/easydesk-get-vehicle-inventory`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
      },
    });
  },

  GetPoiDetails(token, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/easydesk-get-poi-details`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        poiID: poiID,
      },
    });
  },

  VehiclesApproveRequest(token, requestID, poiID, vehicleID) {
    console.log(token, requestID, poiID, vehicleID);

    let payload = {
      requestID: requestID,
      poiID: poiID,
    };

    if (vehicleID) {
      payload.vehicleID = vehicleID;
    }
    return axios({
      method: 'post',
      url: `${API_URL}flow/easydesk-approve-request`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: payload,
    });
  },

  GetEmanetReports(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/dropbox-report`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        getCached: true,
      },
    });
  },

  GetEPAppPosts(token) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-posts`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        dataEntranceType: 'Easypoint APP API',
        limit: 20000,
      },
    });
  },

  PetKidSetRequestComplete(token, requestID, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/easydesk-set-completed-request`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        requestID,
        poiID,
      },
    });
  },

  DHLSendSign(token, barcode, dhlCustomerSign) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-send-sign`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode,
        dhlCustomerSign,
      },
    });
  },

  DHLCustomerRefuse(token, barcode) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-customer-refuse`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcode
      },
    });
  },

  SendPushNotification(users, title, body) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/send-push-notification-with-user-list`,
      data: {
        users: users,
        title: title,
        body: body,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  // Bildirimleri getirir
  GetUserNotifications(userID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-user-notifications`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  // Bildirimi okundu  işaretler

  SetReadNotification(notificationID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/set-read-notification`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        notificationID: notificationID,
        // Test için userID: "40613899664292277710",
      },
    });
  },

  CancelCheckRoom(checkroomID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/checkroom-cancel`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        checkroomID,
      },
    });
  },

  GetEPServices(token, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-easypoint-services-report`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        startDate,
        endDate,
      },
    });
  },

  GetMalls(token) {
    return axios({
      method: 'post',
      url: `${API_URL}malls/get-malls`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        withOffices: true,
      },
    });
  },

  GetMall(token, mallID) {
    return axios({
      method: 'post',
      url: `${API_URL}malls/get-mall`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID
      },
    });
  },

  UpdateMallInventory(token, mallID, vehicleInventoryWithPrice) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/malls-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id: mallID,
        vehicleInventoryWithPrice
      },
    });
  },

  UpdateMallVehicleInventory(token, mallID, vehicleInventory) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/malls-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id: mallID,
        vehicleInventory
      },
    });
  },

  async getPrims(startDate, endDate, poiID) {
    const token = localStorage.getItem('tokenForService');
    const data = {
      startDate,
      endDate
    };
    if (poiID) {
      data.poiID = poiID;
    }
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-esnaf-prims`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  async calculateVigoPrice(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/calculate-vigo-price`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  async createVigoPost(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/create-vigo-post`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  async GetThirdPartyCargoCourierPosts(pointID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-third-party-cargo-courier-posts`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: "",
    });
  },

  GetTokenForPayment() {
    return axios({
      method: 'post',
      url: `${PAYMENT_API_URL}get-token`,
      data: {
        key: "2pPaZUxjJI1Za7gUnUb1vFGzQt4McE",
        secret: "oaG6Agf0QGkULPScsQOEkKW7Hxy7Vr"
      },
    });
  },

  ListenPayment(token, conversationID) {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}flow/listen`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        conversationID
      },
    });
  },

  PaymentWith3D(token, conversationID, price, name, lastname, phone, holderName, cardNumber, expYear, expMonth, cvc) {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}flow/payment-with-3d`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        conversationID: conversationID,
        totalPrice: price,
        paidPrice: price,
        discount: 0,
        installment: 1,
        currency: "TRY",
        customer: {
          name: name,
          lastname: lastname,
          phone: phone
        },
        creditCardInfos: {
          holderName: holderName,
          cardNumber: cardNumber,
          expYear: expYear,
          expMonth: expMonth,
          cvc: cvc
        },
        willBeStored: false,
        cardAlias: false,
        items: [
          {
            name: "Vigo Motor Courier",
            price: price
          }
        ],
        callback: "http://localhost:8888/craftgate-3ds-html-content.php?id=23469234827364982"
      },
    });
  },

  GetPaymentError(token, conversationID) {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}flow/get-payment-error`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        conversationID
      },
    });
  },
  SetPaid(token, requestID, paymentID, last4Digit) {
    return axios({
      method: "post",
      url: `${API_URL}flow/easydesk-set-paid`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        requestID: requestID,
        paymentID: paymentID,
        creditCardLast4Digit: last4Digit
      },
    });
  },

  async GetDHLCargoRates(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-get-cargo-rates`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  async CreateDHLCargo(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/dhl-create-cargo`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  AddCampaignForm(token, campaignID, title, formElements, description, legalContent) {
    return axios({
      method: "post",
      url: `${API_URL}flow/campaigns-add-form`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        campaignID,
        title,
        formElements,
        description,
        legalContent
      },
    });
  },

  GetCampaignForms(token, campaignID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/campaigns-get-form`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        campaignID
      },
    });
  },

  GetCampaignForm(token, campaignID, formID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/campaigns-get-form`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        campaignID,
        formID
      },
    });
  },

  RemoveCampaignForm(token, formID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/campaigns-remove-form`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        formID
      },
    });
  },

  UpdateCampaignForm(token, campaignID, title, formElements, description, legalContent, formID) {
    console.log({ campaignID, title, formElements, description, legalContent, formID })
    return axios({
      method: "post",
      url: `${API_URL}flow/campaigns-update-form`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        campaignID,
        title,
        formElements,
        description,
        legalContent,
        formID
      },
    });
  },

  AddCampaignQuestion(token, question) {
    return axios({
      method: "post",
      url: `${API_URL}flow/campaigns-create-form-question`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        content: question
      },
    });
  },

  UpdateCampaignQuestion(token, questionID, content) {
    return axios({
      method: "post",
      url: `${API_URL}flow/campaigns-update-form-question`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        questionID,
        content,
      },
    });
  },

  RemoveCampaignQuestion(token, questionID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/campaigns-update-form-question`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        questionID,
        status: "0",
        content: {}
      },
    });
  },

  GetCampaignQuestions(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/campaigns-get-form-questions`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  SubmitCampaignForm(token, data, formID, campaignID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-campaign-form-result`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        data,
        type: "campaign-form",
        formID,
        campaignID
      },
    });
  },

  async ChangeCancelOrderStatus(barcodeList) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/mass-post-deliver`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        barcodes: barcodeList,
      },
    });
  },
  GetSubmittedCampaignForms(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-campaign-form-results`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        type: "campaign-form"
      },
    });
  },
  CreateBolparaCoupon(token, companyID, isCompanyBased, isCampaignBased, campaignID, couponCodes, isOneTime, expiredDateTime, description) {
    return axios({
      method: "post",
      url: `${API_URL}flow/bol-para-create-discount-coupons`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        isCompanyBased,
        isCampaignBased,
        campaignID,
        couponCodes,
        isOneTime,
        expiredDateTime,
        description
      },
    });
  },
  GetBolparaCoupons(token, companyID, campaignID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/bol-para-get-discount-coupons`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        campaignID,
      },
    });
  },
  CancelUnusedBolparaCoupons(token, companyID, campaignID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/bol-para-cancel-unused-discount-coupons`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        campaignID,
      },
    });
  },
  CancelSingleUnusedBolparaCoupon(token, couponID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/bol-para-cancel-discount-coupon`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        couponID
      },
    });
  },
  UseSingleBolparaCoupon(token, companyID, coupon) {
    console.log(companyID)
    return axios({
      method: "post",
      url: `${API_URL}flow/bol-para-set-discount-coupons-as-used`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        coupons: [coupon]
      },
    });
  },
  UseBolparaCoupons(token, companyID, coupons) {
    console.log(companyID)
    return axios({
      method: "post",
      url: `${API_URL}flow/bol-para-set-discount-coupons-as-used`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        coupons
      },
    });
  },
  async GetDropboxLocations() {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/drop-box-get-locations`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  async GetDropboxAllTransactions(locationCode, startDate, endDate) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/dropbox-get-transactions`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        "locationCode": locationCode,
        "startDate": startDate,
        "endDate": endDate
      }
    });
  },

  async GetDropboxLockerLocations() {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/lockers-get-locations`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  async GetDropboxLocationDuration(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/drop-box-get-location-duration`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        "locationCode": locationCode
      }
    });
  },
  async GetDropboxLockersGetLockers(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/lockers-get-lockers`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        "locationCode": locationCode
      }
    });
  },
  async GetDropboxLockersGetLockersDurations(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/lockers-get-durations`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        "locationCode": locationCode
      }
    });
  },
  async GetLocationSettings(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/drop-box-get-location-settings`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        "locationCode": locationCode
      }
    });
  },
  async updateLocationSettings(settingsData) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/drop-box-update-location-settings`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: settingsData
    });
  },
  async GetAllCampaignCoupons(location) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'get',
      url: `https://api.easypoint.com.tr/campaign`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
      }
    });
  },
  async CreateCampaign(couponData) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/drop-box-create-coupon`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: couponData
    });
  },
  async DeleteCampaign(couponID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/drop-box-remove-coupon`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        couponID
      }
    });
  },
  async createCargoistPost(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/kargoist-create-cargo`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  async BoxOperationSendingSMS(phoneNumber, message) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `https://api.easypoint.com.tr/other-services/box-sms`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        "phoneNumber": phoneNumber,
        "message": message,
        "validationCode": "EasyPointSmsSender"
      },
    });
  },

  FormResultChangeStatus(token, requestID, status) {
    console.log(requestID, status)
    return axios({
      method: "post",
      url: `${API_URL}flow/campaign-form-result-change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        requestID,
        status,
      },
    });
  },

  ContactFormResultChangeStatus(token, requestID, status) {
    return axios({
      method: "post",
      url: `${API_URL}flow/contact-form-change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        requestID,
        status,
      },
    });
  },
  GetBolParaCompanyHasCoupon(token, companyID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/bol-para-has-coupon`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID
      },
    });
  },

  GetNewCompanyCoupon(token, companyID, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/bol-para-get-new-coupon`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
        viewedType: "esnaf",
        poiID
      },
    });
  },

  GetContactFormResults(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-contact-forms`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  // GetContactFormResults(token) {
  //   return axios({
  //     method: "post",
  //     url: `${API_URL}flow/get-contact-forms`,
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     }
  //   });
  // },

  async makeDropboxEmpty(sessionID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/empty-drop-box`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        sessionID: sessionID
      }
    });
  },

  async getDropboxStatuses(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-location-post-boxes-statuses`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode
      }
    });
  },
  async DropboxCheckLocker(checkLockerData) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/drop-box-check-locker`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: checkLockerData
    });
  },
  async MakeRentalLoad(payload) {
    // const token = localStorage.getItem('tokenForService'); 
    return axios({
      method: 'post',
      url: `${API_URL}flow/load-locker`,
      headers: {
        // Authorization: `Bearer ${token}`, 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: payload
    });
  },
  async FinishRentalLoad(qrCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/finish-box`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        qrCode: qrCode
      }
    });
  },

  async GetContactForms() {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}flow/get-contact-forms`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetBolParaCampaignHasCoupon(
    token,
    campaignID,
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/bol-para-has-coupon`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID
      },
    });
  },

  GetNewCampaignCoupon(
    token,
    companyID,
    campaignID,
    poiID
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/bol-para-get-new-coupon`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        companyID,
        campaignID,
        viewedType: "esnaf",
        poiID
      },
    });
  },

  CreateBolParaQRShowLog(token, campaignID, poiID) {
    return axios({
      method: 'post',
      url: `${API_URL}flow/create-bol-para-qr-show-log`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID,
        poiID
      },
    });
  },

  EPCentersSetClosedDates(token, easypointIDs, closedDateStart, closedDateEnd) {
    console.log({ easypointIDs, closedDateStart, closedDateEnd })
    return axios({
      method: 'post',
      url: `${API_URL}flow/easypoint-centers-set-closed-dates`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        easypointIDs,
        closedDateStart,
        closedDateEnd
      },
    });
  },

  EPPetCreateSingleCoupon(token, title, mallID, startDate, expireDate, discountType, discountValue, inventory, couponCode) {
    console.log({ title, mallID, startDate, expireDate, discountType, discountValue, inventory, couponCode })
    return axios({
      method: 'post',
      url: `${API_URL}flow/easydesk-create-coupon`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title,
        mallID,
        startDate,
        expiredDate: expireDate,
        discountType,
        discountValue,
        inventory,
        couponCode
      },
    });
  },

  EPPetCreateMassCoupons(token, title, mallID, startDate, expireDate, discountType, discountValue, count) {
    console.log({ title, mallID, startDate, expireDate, discountType, discountValue, count })
    return axios({
      method: 'post',
      url: `${API_URL}flow/easydesk-create-mass-coupons`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title,
        mallID,
        startDate,
        expiredDate: expireDate,
        discountType,
        discountValue,
        count
      },
    });
  },
};
